import { TabPermission } from 'src/app/core';
import { EndSellerNetwork } from '../../../end-seller-network.setup';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const parent = EndSellerNetwork.pages.endSellerManagement;
const path = 'metrics';
const title = 'PAGE.END_SELLER_NETWORK.MANAGEMENT.METRICS.TITLE';

export const EndSellerManagementMetricsTab: TabPermission = PermissionsC.generateTabPermission(
  parent,
  path,
  title
);
